"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Insights = _interopRequireDefault(require("../Insights"));

var _MediaCredits = _interopRequireDefault(require("../MediaCredits"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  font-size: 1em;\n  text-align: center;\n  padding-left: 0;\n  padding-right: 0;\n  background: #fff;\n  border: 1px solid #abb2c1;\n  border-radius: 1px;\n\n  &:focus,\n  &:hover {\n    background: #99caeb;\n    outline: solid 1px #000;\n    outline-offset: 1px;\n    cursor: pointer;\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #000;\n    border: 1px solid #fff;\n\n    &:focus,\n    &:hover {\n      background: #fff;\n      color: #000;\n    }\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #fff;\n    border: 1px solid #000;\n\n    &:focus,\n    &:hover {\n      background: #000;\n      color: #fff;\n    }\n  }\n\n  background: #017acd;\n  border: 1px solid #abb2c1;\n  color: #fff;\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #fff;\n    border: 1px solid #000;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #000;\n    border: 1px solid #fff;\n    color: #fff;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  font-size: 1em;\n  text-align: center;\n  padding-left: 0;\n  padding-right: 0;\n  background: #fff;\n  border: 1px solid #abb2c1;\n  border-radius: 1px;\n\n  &:focus,\n  &:hover {\n    background: #99caeb;\n    outline: solid 1px #000;\n    outline-offset: 1px;\n    cursor: pointer;\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background: #000;\n    border: 1px solid #fff;\n\n    &:focus,\n    &:hover {\n      background: #fff;\n      color: #000;\n    }\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background: #fff;\n    border: 1px solid #000;\n\n    &:focus,\n    &:hover {\n      background: #000;\n      color: #fff;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  & li {\n    display: inline-block;\n    margin-right: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UlNav = _styledComponents.default.span(_templateObject());

var NavItemButton = _styledComponents.default.button(_templateObject2());

var NavItemActiveButton = _styledComponents.default.button(_templateObject3());
/* ensures that larger images don't exceed the slideshow wrapper */


var SlideshowDiv = _styledComponents.default.div(_templateObject4());

var Slideshow = /*#__PURE__*/function (_Component) {
  _inherits(Slideshow, _Component);

  var _super = _createSuper(Slideshow);

  function Slideshow(props) {
    var _this;

    _classCallCheck(this, Slideshow);

    _this = _super.call(this, props);

    if (props.item) {
      var html = _this.parseHtml(props.item.html);

      var lis = html.querySelectorAll('li'); // set up component state so we can retain the selected thumbnail

      _this.state = {
        currentSlide: 0,
        lis: lis
      };
      _this.insights = new _Insights.default();
      _this.onNavClick = _this.onNavClick.bind(_assertThisInitialized(_this));
      _this.renderSlide = _this.renderSlide.bind(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(Slideshow, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.item && nextProps.item.html !== this.props.item.html) {
        var html = this.parseHtml(nextProps.item.html);
        var lis = html.querySelectorAll('li');
        this.setState({
          lis: lis
        });
      }
    }
  }, {
    key: "parseHtml",
    value: function parseHtml(htmlString) {
      if (htmlString && htmlString.length) {
        var parser = new window.DOMParser();
        var xmlDoc = parser.parseFromString(htmlString, 'text/html');
        return xmlDoc;
      }
    }
  }, {
    key: "onNavClick",
    value: function onNavClick(index) {
      var item = this.props.item;
      var slide = this.state.lis[index];
      var slideTitle = slide.querySelector('.HwCmd').innerText; // this parses out the GUID from the IMG src

      var slideSrc = slide.querySelector('img').src;
      var slideHwidWithExt = slideSrc.substring(slideSrc.lastIndexOf('/') + 1);
      var slideHwid = slideHwidWithExt.split('.')[0];
      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'slideshowAction',
        slideshowHwid: item.id,
        slideHwid: slideHwid,
        slideTitle: slideTitle,
        slideIndex: index + 1,
        slideshowItems: this.state.lis.length
      });
      this.props.onSlideSelected(index + 1, item);
      this.setState({
        currentSlide: index
      });
    }
  }, {
    key: "renderSlide",
    value: function renderSlide() {
      var lis = this.state.lis;

      if (lis.length) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hw-sc-slideshow-slide",
          dangerouslySetInnerHTML: {
            __html: lis[this.state.currentSlide].innerHTML
          }
        });
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var onNavClick = this.onNavClick;
      var len = this.state.lis.length;
      var current = this.state.currentSlide + 1;
      var navLis = [];

      if (len > 1) {
        var _loop = function _loop() {
          var num = i;
          var currentItem = i === current;
          /* eslint-disable react/jsx-no-bind */

          navLis.push( /*#__PURE__*/_react.default.createElement("li", {
            key: 'nav_' + i
          }, currentItem ? /*#__PURE__*/_react.default.createElement(NavItemActiveButton, {
            type: "button",
            onClick: function onClick() {
              onNavClick(num - 1);
            }
          }, i) : /*#__PURE__*/_react.default.createElement(NavItemButton, {
            type: "button",
            onClick: function onClick() {
              onNavClick(num - 1);
            }
          }, i)));
          /* eslint-enable react/jsx-no-bind */
        };

        for (var i = 1; i <= len; i++) {
          _loop();
        }
      }

      return /*#__PURE__*/_react.default.createElement(UlNav, null, navLis);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          hideDisclaimer = _this$props.hideDisclaimer;
      var toReturn = null;
      var previewItems = [];
      this.state.lis.forEach(function (element, i) {
        var src = element.querySelector('img').src;
        previewItems.push( /*#__PURE__*/_react.default.createElement("img", {
          src: src,
          alt: "",
          key: 'preload-image-' + i
        }));
      });

      if (item) {
        toReturn = /*#__PURE__*/_react.default.createElement(SlideshowDiv, {
          className: 'hw-sc-slideshow'
        }, this.renderSlide(), /*#__PURE__*/_react.default.createElement(_MediaCredits.default, {
          hideDisclaimer: hideDisclaimer,
          asOfDate: item.certifiedDate,
          legal: item.legal,
          credits: item.credits
        }), this.renderNavigation(), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'none'
          },
          "aria-hidden": "true"
        }, previewItems));
      }

      return toReturn;
    }
  }]);

  return Slideshow;
}(_react.Component);

Slideshow.propTypes = {
  item: _propTypes.default.object.isRequired,
  hideDisclaimer: _propTypes.default.bool,
  onSlideSelected: _propTypes.default.func
};
Slideshow.defaultProps = {
  hideDisclaimer: false,
  onSlideSelected: function onSlideSelected() {}
};
var _default = Slideshow;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/content/Slideshow/index.js